import {ClsConfig} from '../../../util/cls-config';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsUtil} from '../../../util/cls-util';
import {ExcelUtility} from '../../../util/excel-utility';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {Workbook, Worksheet} from 'igniteui-angular-excel';
import {EnumTipoParametro} from '../../../core/models/enum/enum-tipo-parametro';
import { ClsListaArchivos } from 'src/app/core/models/cls-storage';
import {inject} from "@angular/core";
import {ClsDatosEncabezadoSobrecosto, IFechasPeriodo, IMontoPeriodo} from "../../../core/models/cls-sobrecosto";
import {ClsPrograma} from "../../../core/models/cls-programa";
import {AppInfoService} from "../../../core/services/app-info.service";
import {EnumPeriodicidad} from "../../../core/models/enum/enum-programacion-obra";
import {ClsFechasPeriodos} from "../programacion-obra/cls-fechas-periodos";

export class ClsObjSobrecosto extends ClsConfig {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);

  public mHojaDatosObra: Worksheet;
  // LIBRO SOBRECOSTO
  public static readonly NOMBRE_HOJA_N_CAMPOS_GRLS = 'N_Campos Generales';
  public static readonly NOMBRE_HOJA_DATOS_OBRA = 'DatosObra';
  public static readonly NOMBRE_HOJA_PROGRAMA = 'Programa';
  public static readonly NOMBRE_HOJA_PLANTILLA = 'a)Plantilla';
  public static readonly NOMBRE_HOJA_INDDESG = 'b)Indirectos Desglosados';
  public static readonly NOMBRE_HOJA_RESIND = 'c)Resumen Indirectos';
  public static readonly NOMBRE_HOJA_PERTEC = 'd)Pers.Técnico';
  public static readonly NOMBRE_HOJA_PERTEC$ = 'e)Pers.Técnico$';
  public static readonly NOMBRE_HOJA_FINANCIAMENTO = 'f)Financiamiento';
  public static readonly NOMBRE_HOJA_UTILIDAD = 'g)Utilidad';
  public static readonly NOMBRE_HOJA_CARGADIC = 'h)Cargos_Adicionales';
  public static readonly NOMBRE_HOJA_RESUMEN = 'i)Resumen';
  public mHojaCamposGenerales: Worksheet;
  public mHojaPrograma: Worksheet;
  public mHojaPlantilla: Worksheet;
  public mHojaIndDesg: Worksheet;
  public mHojaResInd: Worksheet;
  public mHojaPerTec: Worksheet;
  public mHojaPerTec$: Worksheet;
  public mHojaFinanciamiento: Worksheet;
  public mHojaUtilidad: Worksheet;
  public mHojaCargAdic: Worksheet;
  public mHojaiResumen: Worksheet;

  // LIBRO INDIRECTOS
  public static readonly NOMBRE_HOJA_DATOS= 'Datos';
  public static readonly NOMBRE_HOJA_CALCULO = 'Calculo';
  public mHojaCalculo: Worksheet;

  // OBJ
  public mObjGenerico: ClsObjGenerico;
  private mObjFechasPeriodos: ClsFechasPeriodos = new ClsFechasPeriodos();
  // propiedades
  private _MESMONEDA1: boolean;
  private _MESLIBROINDIRECTO: boolean = false;
  private _MLIBRO: Workbook;
  private _MFACTORINDIRECTOPIE: number;
  private _MFACTORINDIRECTO: number;
  private _MFACTORFINANCIAMIENTO: number;
  private _MFACTORUTILIDAD: number;
  private _MFACTORCARGOSADICIONALES: number;
  private _MFACTORINDIRECTOSCAMPO: number;
  private _MFACTORINDIRECTOSOFICINACENTRAL: number;
  private _COSTO93: number;
  private _COSTO94: number;
  private _COSTO95: number;
  private _COSTO96: number;
  private _COSTO97: number;
  private _COSTO98: number;
  private _COSTO99: number;
  private _INDESPECIAL: boolean;
  /** Datos encabezado libro sobrecosto (DatosObra) y resultados hoja i)Resumen */
  private _TipoAnticipo: number;
  private _PorcentajeAnticipo1: number;
  private _PorcentajeAnticipo2: number;
  private _PeriodoEntregaAnticipo2: number;
  private _ImporteEjercicio1: number;

  set MESMONEDA1(value: boolean) {
    this._MESMONEDA1 = value;
  }

  get MESMONEDA1(): boolean {
    return this._MESMONEDA1;
  }

  get MESLIBROINDIRECTO(): boolean {
    return this._MESLIBROINDIRECTO;
  }

  set MESLIBROINDIRECTO(value: boolean) {
    this._MESLIBROINDIRECTO = value;
  }

  set MLIBRO(value: Workbook) {
    this._MLIBRO = value;
  }

  get MLIBRO(): Workbook {
    return this._MLIBRO;
  }

  get FactorIndirectoPie(): number {
    return this._MFACTORINDIRECTOPIE;
  }

  set FactorIndirectoPie(value: number) {
    this._MFACTORINDIRECTOPIE = value;
  }

  get FactorIndirecto(): number {
    return this._MFACTORINDIRECTO;
  }

  set FactorIndirecto(value: number) {
    this._MFACTORINDIRECTO = value;
  }

  get FactorFinanciamiento(): number {
    return this._MFACTORFINANCIAMIENTO;
  }

  set FactorFinanciamiento(value: number) {
    this._MFACTORFINANCIAMIENTO = value;
  }

  get FactorUtilidad(): number {
    return this._MFACTORUTILIDAD;
  }

  set FactorUtilidad(value: number) {
    this._MFACTORUTILIDAD = value;
  }

  get FactorCargosAdicionales(): number {
    return this._MFACTORCARGOSADICIONALES;
  }

  set FactorCargosAdicionales(value: number) {
    this._MFACTORCARGOSADICIONALES = value;
  }

  get FactorIndirectosCampo(): number {
    return this._MFACTORINDIRECTOSCAMPO;
  }

  set FactorIndirectosCampo(value: number) {
    this._MFACTORINDIRECTOSCAMPO = value;
  }

  get FactorIndirectosOficinaCentral(): number {
    return this._MFACTORINDIRECTOSOFICINACENTRAL;
  }

  set FactorIndirectosOficinaCentral(value: number) {
    this._MFACTORINDIRECTOSOFICINACENTRAL = value;
  }

  get Costo93(): number {
    return this._COSTO93;
  }

  set Costo93(value: number) {
    this._COSTO93 = value;
  }

  get Costo94(): number {
    return this._COSTO94;
  }

  set Costo94(value: number) {
    this._COSTO94 = value;
  }

  get Costo95(): number {
    return this._COSTO95;
  }

  set Costo95(value: number) {
    this._COSTO95 = value;
  }

  get Costo96(): number {
    return this._COSTO96;
  }

  set Costo96(value: number) {
    this._COSTO96 = value;
  }

  get Costo97(): number {
    return this._COSTO97;
  }

  set Costo97(value: number) {
    this._COSTO97 = value;
  }

  get Costo98(): number {
    return this._COSTO98;
  }

  set Costo98(value: number) {
    this._COSTO98 = value;
  }

  get Costo99(): number {
    return this._COSTO99;
  }

  set Costo99(value: number) {
    this._COSTO99 = value;
  }

  get IndEspecial(): boolean {
    return this._INDESPECIAL;
  }

  set IndEspecial(value: boolean) {
    this._INDESPECIAL = value;
  }

  get TipoAnticipo(): number {
    return this._TipoAnticipo ?? 0;
  }
  set TipoAnticipo(value: number) {
    this._TipoAnticipo = value;
  }
  get PorcentajeAnticipo1(): number {
    return this._PorcentajeAnticipo1 ?? 0;
  }
  set PorcentajeAnticipo1(value: number) {
    this._PorcentajeAnticipo1 = value;
  }
  get PorcentajeAnticipo2(): number {
    return this._PorcentajeAnticipo2 ?? 0;
  }
  set PorcentajeAnticipo2(value: number) {
    this._PorcentajeAnticipo2 = value;
  }
  get PeriodoEntregaAnticipo2(): number {
    return this._PeriodoEntregaAnticipo2 ?? 0;
  }
  set PeriodoEntregaAnticipo2(value: number) {
    this._PeriodoEntregaAnticipo2 = value;
  }
  get ImporteEjercicio1(): number {
    return this._ImporteEjercicio1 ?? 0;
  }
  set ImporteEjercicio1(value: number) {
    this._ImporteEjercicio1 = value;
  }

  constructor() {
    super();
  }

  public setValoresHojaPieIndirecto(): Workbook {
    try {
      this.setHojasSobrecostoIndirecto();
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'IndirectosGlobales', this._MFACTORINDIRECTO);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'IndirectosCentrales', this._MFACTORINDIRECTOSOFICINACENTRAL);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'IndirectosCampo', this._MFACTORINDIRECTOSCAMPO);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Financiamiento', this._MFACTORFINANCIAMIENTO);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Utilidad', this._MFACTORUTILIDAD);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'CargoAdicional', this._MFACTORCARGOSADICIONALES);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'DecimalesRedondeo', this.infPpto.decimalredondearimporte);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo93', this._COSTO93);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo94', this._COSTO94);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo95', this._COSTO95);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo96', this._COSTO96);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo97', this._COSTO97);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo98', this._COSTO98);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'CostoDirecto', this._COSTO99);
      // esto nada mas se ocupa cuando tiene ind especial la matriz
      if (this._INDESPECIAL) {
        ClsUtil.vaciaValorHoja(this.mHojaCalculo, 'A2', 'Costo directo');
        ClsUtil.vaciaValorHoja(this.mHojaCalculo, 'A3', 'Indirecto Especial');
        ClsUtil.vaciaValorHoja(this.mHojaCalculo, 'A4', 'PRECIO UNITARIO');
      }
      this._MFACTORINDIRECTOPIE = ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'PrecioUnitario') - 100;
      return this.MLIBRO;
    } catch (e) {
      throw new Error(e.message);
    }
  }


  public setHojasSobrecostoIndirecto() {
    try {
      // setear hojas
      if (!this.MESLIBROINDIRECTO) {
        this.mHojaCamposGenerales = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_N_CAMPOS_GRLS));
        this.mHojaDatosObra = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_DATOS_OBRA));
        this.mHojaPrograma = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_PROGRAMA));
        this.mHojaPlantilla = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_PLANTILLA));
        this.mHojaIndDesg = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_INDDESG));
        this.mHojaResInd = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_RESIND));
        this.mHojaPerTec = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_PERTEC));
        this.mHojaPerTec$ = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_PERTEC$));
        this.mHojaFinanciamiento = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_FINANCIAMENTO));
        this.mHojaUtilidad = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_UTILIDAD));
        this.mHojaCargAdic = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_CARGADIC));
        this.mHojaiResumen = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_RESUMEN));

      }
      if (this.MESLIBROINDIRECTO) {
        this.mHojaDatosObra = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO, ClsObjSobrecosto.NOMBRE_HOJA_DATOS));
        this.mHojaCalculo = this.MLIBRO.worksheets(ClsUtil.ubicaHoja(this.MLIBRO,  ClsObjSobrecosto.NOMBRE_HOJA_CALCULO));
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  /**
   * Metodo para validar las hojas necesarias para realizar los calculos necesarios
   * @param file
   * @param esLibroIndirecto
   */
  public async validarHojasPIANDSCSubirArchivoLocal(file: File, esLibroIndirecto: boolean) {
    try {
      const libro: any = await ExcelUtility.loadXLSX(file);
      this.MESLIBROINDIRECTO = esLibroIndirecto;
      if (!this.MESLIBROINDIRECTO) {
        const indexNCampGrals = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_N_CAMPOS_GRLS);
        const indexDatos = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_DATOS_OBRA);
        const indexPrograma = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_PROGRAMA);
        const indexPlantilla = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_PLANTILLA);
        const indexIndDesg = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_INDDESG);
        const indexResInd = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_RESIND);
        const indexPerTec = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_PERTEC);
        const indexPerTec$ = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_PERTEC$);
        const indexFinanciamiento = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_FINANCIAMENTO);
        const indexUtilidad = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_UTILIDAD);
        const indexCargAdic = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_CARGADIC);
        const indexResumen = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_RESUMEN);

        if (indexNCampGrals === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_CAMPOS_GRALS');
        }
        if (indexDatos === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_OBRA');
        }
        if (indexPrograma === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_PROGRAMA');
        }
        if (indexPlantilla === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_PLANTILLA');
        }
        if (indexIndDesg === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_INDDESG');
        }
        if (indexResInd === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_CRESIND');
        }
        if (indexPerTec === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_PERTEC');
        }
        if (indexPerTec$ === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_PERTEC$');
        }
        if (indexFinanciamiento === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_FINANCIAMIENTO');
        }
        if (indexUtilidad === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_UTILIDAD');
        }
        if (indexCargAdic === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_CARGADIC');
        }
        if (indexResumen === -1) {
          throw new Error('MENSAJES.ALERT.LIBRO_DATOS_RESUMEN');
        }
      }
      if (this.MESLIBROINDIRECTO) {
        const indexDatos = ExcelUtility.ubicaHojaXLSX(libro, ClsObjSobrecosto.NOMBRE_HOJA_DATOS);
        const indexCalculo = ExcelUtility.ubicaHojaXLSX(libro,  ClsObjSobrecosto.NOMBRE_HOJA_CALCULO);
        if (indexDatos === -1) {
          throw new Error('MENSAJES.ERROR.HOJA_DATOS');
        }
        if (indexCalculo === -1) {
          throw new Error('MENSAJES.ERROR.HOJA_CALCULO');
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public getValoresHojaPieIndirecto() {
    const indexDatos: number = ClsUtil.ubicaHoja(this.MLIBRO, 'Datos');
    const hojaDatos: Worksheet = this.MLIBRO.worksheets(indexDatos);
    this._MFACTORINDIRECTO = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'IndirectosGlobales');
    this._MFACTORINDIRECTOSOFICINACENTRAL = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'IndirectosCentrales');
    this._MFACTORINDIRECTOSCAMPO = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'IndirectosCampo');
    this._MFACTORFINANCIAMIENTO = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'Financiamiento');
    this._MFACTORUTILIDAD = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'Utilidad');
    this._MFACTORCARGOSADICIONALES = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'CargoAdicional');
    this._MFACTORINDIRECTOPIE = ClsUtil.obtieneValorDecimalHoja(hojaDatos, 'PrecioUnitario') - 100;
  }

  public async guardarArchivoStorage(idPpto: bigint, listaArchivos: ClsListaArchivos[], docSelec: ClsListaArchivos, nomArchivo: string, prefixMoneda: string, esSobrecosto: boolean) {
    // buscamos si hay algun archivo para la Moneda 1 o 2, dependiendo del prefixMoneda
    let nomPrefixPpto: string;
    const hayArchivo: ClsListaArchivos = listaArchivos.find(value => value.NombreArchivo.includes(prefixMoneda));
    if (!ClsUtil.esNulo(hayArchivo)) {
      nomPrefixPpto = esSobrecosto ? this.gNomPrefixPptoSC : this.gNomPrefixPptoPI;
      const nomArchivo2 = `${nomPrefixPpto}/${hayArchivo.Documento.replace(prefixMoneda, '')}${prefixMoneda}${hayArchivo.Extension}`;
      // verificar si es diferente el archivo de arriba con el nuevo para borrar el de arriba y guardar el nuevo
      // en caso de ser el mismo no se borra, ya que en el storage si se llama igual el archivo se reemplaza
      if (nomArchivo !== nomArchivo2) {
        await ClsUtil.borrarArchivoStorage(idPpto.toString(), nomArchivo2.split('/')[1], this.gNomBocketPpto, nomPrefixPpto, this.mObjGenerico);
      }
    }
    await this.mObjGenerico.subirArchivosStorage(EnumTipoParametro.Presupuesto, this.gNomBocketPpto, nomArchivo, docSelec.ContenidoBase64, idPpto, docSelec.TipoArchivo);
  }

  public async inicializarDatosSubirArchivoLocal(file: File, prefix: string, esLibroIndirecto: boolean, validarHojas = true): Promise<ClsListaArchivos> {
    try {
      if (validarHojas) {
        await this.validarHojasPIANDSCSubirArchivoLocal(file, esLibroIndirecto);
      }
      return  await ClsUtil.inicializarDatosSubirArchivoLocal(file, prefix);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Limpia y escribe los datos del encabezado en la hoja DatosObra (equivalente VB: LimpiaDatosEncabezado + VaciaDatosEncabezado).
   * Debe llamarse antes de abrir la vista previa del libro sobrecosto para que el usuario vea los valores actuales del formulario.
   */
  public async prepararYVaciarDatosEncabezadoSobrecosto(datos: ClsDatosEncabezadoSobrecosto): Promise<void> {
    this.setHojasSobrecostoIndirecto();

    // limpia todos los datos generales a la hoja de campos generales
    this.infPpto.mapCamposGenerales.forEach((value, key) => {
      ClsUtil.vaciaValorHoja(this.mHojaCamposGenerales, key, '');
    });
    // envia todos los datos generales a la hoja de campos generales
    this.infPpto.mapCamposGenerales.set('plazocalculado', datos.plazocalculado);
    this.infPpto.mapCamposGenerales.set('plazoreal', datos.plazoreal);
    this.infPpto.mapCamposGenerales.forEach((value, key) => {
      ClsUtil.vaciaValorHoja(this.mHojaCamposGenerales, key, value);
    });

    const n = (v: number) => (v == null || Number.isNaN(v) ? 0 : Number(v));
    const s = (v: string) => (v == null ? '' : String(v).trim());

    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Costo_directo', n(datos.costoDirecto));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Mano_Gravable', n(datos.importeManoObraGravable));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Importe_TotalObra', n(datos.importeTotalObra));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Factor_SFP', n(datos.factorSFP));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'Porcentaje_Utilidad_Propuesta', n(datos.utilidadPropuesta));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'TasaInteres', n(datos.tasaInteres));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'PuntosBanco', n(datos.puntosBanco));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'IndicadorEcon1', s(datos.indicadorEconomico));
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'TipoDeAnticipo', Math.floor(n(datos.tipoAnticipo)) || 1);

    // LIMPIAR DATOS
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EJERCICIO', 0);
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EXHIBICION1', 0);
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EXHIBICION2', 0);
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EJERCICIO1', 0);
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EJERCICIO2', 0);
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'PeriodoEntregaAnticipo2', 0);
    ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'ImporteEjercerEjercicio1', 0);

    const tipo = Math.floor(n(datos.tipoAnticipo)) || 1;
    if (tipo === 1) {
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EJERCICIO', n(datos.porcentajeAnticipo1) / 100);
    } else if (tipo === 2) {
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EXHIBICION1', n(datos.porcentajeAnticipo1) / 100);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EXHIBICION2', n(datos.porcentajeAnticipo2) / 100);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'PeriodoEntregaAnticipo2', Math.floor(n(datos.periodoEntregaAnticipo2)));
    } else if (tipo === 3) {
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EJERCICIO1', n(datos.porcentajeAnticipo1) / 100);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'EJERCICIO2', n(datos.porcentajeAnticipo2) / 100);
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'PeriodoEntregaAnticipo2', Math.floor(n(datos.periodoEntregaAnticipo2)));
      ClsUtil.vaciaValorHoja(this.mHojaDatosObra, 'ImporteEjercerEjercicio1', n(datos.importeEjercicio1));
    }

    // LIMPIAR DATOS PROGRAMA Y SETEAR AInicio, fechasInicio y fechasFinal
    this.limpiaDatosPrograma();
    if (!ClsUtil.esNulo(datos.anoInicio) && !Number.isNaN(Number(datos.anoInicio))) {
      ClsUtil.vaciaValorHoja(this.mHojaPrograma, 'AInicio', Math.floor(Number(datos.anoInicio)));
    }
    if (!ClsUtil.esNulo(datos.fechaInicio)) {
      ClsUtil.vaciaValorHoja(this.mHojaCamposGenerales, 'fechainicio', ClsUtil.formatoFechaManualPipe(datos.fechaInicio, 'dd/MM/yyyy'));
    }
    if (!ClsUtil.esNulo(datos.fechaFinal)) {
      ClsUtil.vaciaValorHoja(this.mHojaCamposGenerales, 'fechaterminacion', ClsUtil.formatoFechaManualPipe(datos.fechaFinal, 'dd/MM/yyyy'));
    }
  }

  /**
   * Equivalente VB LimpiaDatosPrograma (líneas 819-833 y 837-907): limpia los datos de la hoja Programa.
   * Obtiene fila/columna desde DatosObra para TituloPeriodo, DiasNaturales, DiasPeriodos, AnoPeriodo,
   * TCostoDirecto, TImporte, TMateriales, TManoObra, TEquipo, TOtrosInsumos; luego vacía 125 filas
   * en la hoja Programa con los mismos desplazamientos (consecutivo periodo "", título "", días 0, etc.).
   */
  private limpiaDatosPrograma(): void {
    if (!this.mHojaPrograma) return;

    const titulo = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TituloPeriodo');
    const diasNat = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'DiasNaturales');
    const diasPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'DiasPeriodos');
    const anoPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'AnoPeriodo');
    const cdPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TCostoDirecto');
    const impPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TImporte');
    const costoMa = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TMateriales');
    const costoMo = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TManoObra');
    const costoEq = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TEquipo');
    const costoOtros = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TOtrosInsumos');

    if (titulo.fila < 0 || titulo.columna < 0) return;

    const colProgramadoPeriodo = titulo.columna - 1;

    for (let i = 1; i <= 125; i++) {
      const filaProg = titulo.fila + i;
      const filaTit = titulo.fila + i;
      const filaDiasP = diasPer.fila + i;
      const filaDiasN = diasNat.fila + i;
      const filaAno = anoPer.fila + i;
      const filaCD = cdPer.fila + i;
      const filaImp = impPer.fila + i;
      const filaMa = costoMa.fila + i;
      const filaMo = costoMo.fila + i;
      const filaEq = costoEq.fila + i;
      const filaOtros = costoOtros.fila + i;

      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaProg, colProgramadoPeriodo, '');
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaTit, titulo.columna, '');
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaDiasP, diasPer.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaDiasN, diasNat.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaAno, anoPer.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaCD, cdPer.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaImp, impPer.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaMa, costoMa.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaMo, costoMo.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaEq, costoEq.columna, 0);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaOtros, costoOtros.columna, 0);
    }
  }

  /**
   * Rellena la hoja Programa con los datos del programa y montos por periodo (equivalente VB VaciaDatosPrograma líneas 835-906:
   * DtMontosPeriodos + hFechasPeriodo, TextoPeriodicidad, consecutivo, título, días, año, Costo/Precio/CostoMA/CostoMO/CostoEQ/CostoOtros).
   * Debe llamarse después de prepararYVaciarDatosEncabezadoSobrecosto cuando se tenga programa y montos (no volver a obtener el programa).
   */
  public llenarDatosPrograma(programa: ClsPrograma, montosPeriodos: IMontoPeriodo[]): void {
    if (!this.mHojaPrograma || !programa) return;
    const periodos = programa.NoPeriodos ?? 0;
    if (periodos <= 0) return;

    const fechasPeriodos: Map<number, IFechasPeriodo> =  this.mObjFechasPeriodos.calcularFechasPeriodo(programa);
    if (fechasPeriodos.size !== periodos) return;

    const titulo = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TituloPeriodo');
    const diasNat = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'DiasNaturales');
    const diasPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'DiasPeriodos');
    const anoPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'AnoPeriodo');
    const cdPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TCostoDirecto');
    const impPer = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TImporte');
    const costoMa = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TMateriales');
    const costoMo = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TManoObra');
    const costoEq = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TEquipo');
    const costoOtros = ClsUtil.obtieneFilaColumna(this.mHojaPrograma, 'TOtrosInsumos');
    if (titulo.fila < 0 || titulo.columna < 0) return;

    const colProgramadoPeriodo = titulo.columna - 1;
    const periodicidad = Math.floor(Number(programa.Periodicidad)) || 1;
    const textoPeriodicidad = periodicidad === 1 ? 'Mes' : periodicidad === 2 ? 'Quincena' : periodicidad === 3 ? 'Semana' : 'Dia';
    const fechaInicioPrograma = programa.FechaInicio instanceof Date ? new Date(programa.FechaInicio) : new Date(programa.FechaInicio as any);
    const fechaFinPrograma = programa.FechaFinal instanceof Date ? new Date(programa.FechaFinal) : new Date(programa.FechaFinal as any);
    const n = (v: number) => (v == null || Number.isNaN(v) ? 0 : Number(v));

    for (let i = 1; i <= periodos; i++) {
      const dat = fechasPeriodos.get(i);
      const filaProg = titulo.fila + i;
      const filaTit = titulo.fila + i;
      const filaDiasP = diasPer.fila + i;
      const filaDiasN = diasNat.fila + i;
      const filaAno = anoPer.fila + i;
      const filaCD = cdPer.fila + i;
      const filaImp = impPer.fila + i;
      const filaMa = costoMa.fila + i;
      const filaMo = costoMo.fila + i;
      const filaEq = costoEq.fila + i;
      const filaOtros = costoOtros.fila + i;

      const diasPeriodo = Math.floor((dat.fechaFinal.getTime() - dat.fechaInicio.getTime()) / (24 * 60 * 60 * 1000)) + 1;
      let diasNaturales: number;
      if (periodos === 1) {
        diasNaturales = Math.floor((fechaFinPrograma.getTime() - fechaInicioPrograma.getTime()) / (24 * 60 * 60 * 1000)) + 1;
      } else if (i === 1) {
        diasNaturales = Math.floor((dat.fechaFinal.getTime() - fechaInicioPrograma.getTime()) / (24 * 60 * 60 * 1000)) + 1;
      } else if (i === periodos) {
        diasNaturales = Math.floor((fechaFinPrograma.getTime() - dat.fechaInicio.getTime()) / (24 * 60 * 60 * 1000)) + 1;
      } else {
        diasNaturales = Math.floor((dat.fechaFinal.getTime() - dat.fechaInicio.getTime()) / (24 * 60 * 60 * 1000)) + 1;
      }
      const anoPeriodo = i === 1 ? fechaInicioPrograma.getFullYear() : dat.fechaInicio.getFullYear();

      const montos = montosPeriodos[i - 1];
      const costo = montos ? n(montos.costo) : 0;
      const precio = montos ? n(montos.precio) : 0;
      const costoMA = montos ? n(montos.costoMA) : 0;
      const costoMO = montos ? n(montos.costoMO) : 0;
      const costoEQ = montos ? n(montos.costoEQ) : 0;
      const costoOtrosVal = montos ? n(montos.costoOtros) : 0;

      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaProg, colProgramadoPeriodo, i);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaTit, titulo.columna, textoPeriodicidad + i);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaDiasP, diasPer.columna, diasPeriodo);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaDiasN, diasNat.columna, diasNaturales);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaAno, anoPer.columna, anoPeriodo);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaCD, cdPer.columna, costo);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaImp, impPer.columna, precio);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaMa, costoMa.columna, costoMA);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaMo, costoMo.columna, costoMO);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaEq, costoEq.columna, costoEQ);
      ClsUtil.vaciaValorHojaPorFilaColumna(this.mHojaPrograma, filaOtros, costoOtros.columna, costoOtrosVal);
    }
  }

  /**
   * Lee los valores calculados de la hoja i)Resumen y actualiza las propiedades de la clase (equivalente VB: ObtieneValoresHoja/RegresaValoresSobreCosto).
   * Debe llamarse al guardar el libro desde la vista previa para actualizar el formulario con los resultados.
   */
  public obtenerValoresResumenSobrecosto(): void {
    this.setHojasSobrecostoIndirecto();
    const redondea = (v: number, d: number) => (v == null || Number.isNaN(v) ? 0 : Number(Number(v).toFixed(d)));
    const x = (v: number) => (v == null || Number.isNaN(v) ? 0 : Number(v));

    this._MFACTORINDIRECTO = redondea(ClsUtil.obtieneValorDecimalHoja(this.mHojaIndDesg, 'Porcentaje_Indirecto'), 7) * 100;
    this._MFACTORINDIRECTOSCAMPO = redondea(ClsUtil.obtieneValorDecimalHoja(this.mHojaIndDesg, 'Porcentaje_Campo'), 7) * 100;
    this._MFACTORINDIRECTOSOFICINACENTRAL = redondea(ClsUtil.obtieneValorDecimalHoja(this.mHojaIndDesg, 'Porcentaje_Central'), 7) * 100;
    this._MFACTORFINANCIAMIENTO = redondea(ClsUtil.obtieneValorDecimalHoja(this.mHojaFinanciamiento, 'PorcentajeFinanciamiento'), 6) * 100;
    this._MFACTORUTILIDAD = redondea(ClsUtil.obtieneValorDecimalHoja(this.mHojaUtilidad, 'Porcentaje_Utilidad'), 6) * 100;
    this._MFACTORCARGOSADICIONALES = redondea(ClsUtil.obtieneValorDecimalHoja(this.mHojaCargAdic, 'Porcentaje_CargoAdicional'), 6) * 100;

    this._TipoAnticipo = Math.floor(x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'TipoDeAnticipo'))) || 1;
    if (this._TipoAnticipo === 1) {
      this._PorcentajeAnticipo1 = x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'EJERCICIO')) * 100;
      this._PorcentajeAnticipo2 = 0;
      this._PeriodoEntregaAnticipo2 = 0;
      this._ImporteEjercicio1 = 0;
    } else if (this._TipoAnticipo === 2) {
      this._PorcentajeAnticipo1 = x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'EXHIBICION1')) * 100;
      this._PorcentajeAnticipo2 = x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'EXHIBICION2')) * 100;
      this._PeriodoEntregaAnticipo2 = Math.floor(x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'PeriodoEntregaAnticipo2')));
      this._ImporteEjercicio1 = 0;
    } else {
      this._PorcentajeAnticipo1 = x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'EJERCICIO1')) * 100;
      this._PorcentajeAnticipo2 = x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'EJERCICIO2')) * 100;
      this._PeriodoEntregaAnticipo2 = Math.floor(x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'PeriodoEntregaAnticipo2')));
      this._ImporteEjercicio1 = x(ClsUtil.obtieneValorDecimalHoja(this.mHojaDatosObra, 'ImporteEjercerEjercicio1'));
    }
  }
}
